module.exports = __webpack_public_path__ + "img/Wasserfall.cd4b1817.jpg";